import React, { useEffect } from "react";
import { Box, Typography, Grid } from "@mui/material";
import { styled } from "@mui/system";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useSelector, useDispatch } from "react-redux";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import SchoolAbout from "../Components/SchoolAbout";
import ExamAbout from "../Components/ExamAbout"
import { fetchHomeBanners } from "../redux/actions/admin/homeBannerActions";
import { fetchGalleryImages } from "../redux/actions/admin/galleryAction";
import CallToEnroll from "../Components/CallToEnroll";
import SchoolPrograms from "../Components/SchoolPrograms";
import { useNavigate } from "react-router-dom";
import Enquiry from "../Components/Enquiry";
import NoticeSection from "../Components/NoticeSection";
import PageTitle from "../Components/PageTitle";
import HomeHighlightsCarousel from "../Components/HomeHighlightsCarousel";

const BannerContainer = styled(Box)({
  position: "relative",
  overflow: "hidden",
  width: "100%",
});

const BannerImage = styled(Box)({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#000",
});

const Home = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { images } = useSelector((state) => state.homeBanner);
  const { images: getImage } = useSelector((state) => state.gallery);

  useEffect(() => {
    dispatch(fetchHomeBanners());
  }, [dispatch]);

  const settings = {
    dots: false,
    infinite: images?.length > 1, // infinite only if there are multiple images
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  useEffect(() => {
    dispatch(fetchGalleryImages());
  }, [dispatch]);

  return (
    <>
      <Navbar />
      <PageTitle
        title="Shree Mangalam School - RIMC & Military School Coaching"
        description="Join Shree Mangalam School, a leading coaching institute for RIMC, Sainik School, and Military School entrance exams. Expert faculty, top results, and modern facilities."
        keywords="RIMC coaching, Military school entrance, Sainik School preparation, Shree Manglam coaching, Jaipur best school coaching"
      />
      <BannerContainer>
        <Slider {...settings}>
          {images?.map((url, index) => (
            <BannerImage
              key={index}
              sx={{
                height: {
                  xs: "300px",
                  sm: "300px",
                  md: "620px",
                  lg: "620px",
                },
                width: "100%",
              }}
            >
              <img
                src={url?.imageUrl}
                alt={`Slide ${index + 1}`}
                style={{
                  height: "100%",
                  width: "100%",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  position: "relative",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              />
            </BannerImage>
          ))}
        </Slider>
      </BannerContainer>

      <HomeHighlightsCarousel />

      <Enquiry />
      <SchoolAbout />
      <ExamAbout />
      <NoticeSection />
      <SchoolPrograms />

      {/*  Our Gallery */}
      <Box sx={{ p: 3.5 }}>
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Typography
              variant="h4"
              sx={{
                fontFamily: "Poppins, sans-serif",
                fontOpticalSizing: "auto",
                fontStyle: "normal",
                letterSpacing: 1,
                color: "#065A79",
                fontWeight: "bold",
                mt: 2,
              }}
              gutterBottom
            >
              {/* Our Gallery */}
              Celebrating Every Moment
            </Typography>
          </Box>
        </Box>

        <Grid container spacing={3} pt={1} mb={5} mt={3}>
          {getImage?.slice(0, 4).map((image, index) => (
            <Grid item key={index} xs={12} sm={6} md={3}>
              <Box
                sx={{
                  position: "relative",
                  borderRadius: "15px",
                  overflow: "hidden",
                  boxShadow: 3,
                  cursor: "pointer",
                  transition: "transform 0.3s ease-in-out",
                  "&:hover": {
                    transform: "scale(1.02)",
                  },
                }}
                onClick={() => navigate("/gallery")}
              >
                <img
                  src={image.imageUrl}
                  alt={`uploaded-banner-${index}`}
                  style={{
                    height: "350px",
                    width: "100%",
                    objectFit: "cover",
                  }}
                />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>

      <CallToEnroll />
      <Footer />
    </>
  );
};

export default Home;
